
import { Component, Mixins, Model, Watch, Emit } from "vue-property-decorator";
import { ObjectUtility } from "../../../utilities";
import { DisableableMixin } from ".";
import { IRestrictions } from "../../document/editor/EditingDocument";
import { IRestriction } from "../../system";

@Component({
})
// 残念ながらMixinのジェネリクスはvue-property-decoratorが上手く処理できない模様.any型で.
export default class ModelEditableMixin extends Mixins(DisableableMixin) {
  @Model("input")
  value: any;

  private _updatingValue: any;

  get isSourceEnable(): boolean {
    return !!this.value;
  }

  get editingSource(): any {
    return this.value;
  }

  set editingSource(value: any) {
    this.input(value);
  }

  get editingRestrictions(): IRestrictions {
    return this.editingSource
      ? this.editingSource.restrictions
      : null;
  }

  get shouldValidate(): boolean {
    return !this.isRestricted(s => s.validation);
  }

  get cloneEditingSource(): (source: any) => any {
    if (!this._cloneEditingSource) {
      this._cloneEditingSource = ModelEditableMixin._cloneSourceDefault;
    }
    return this._cloneEditingSource;
  }

  set cloneEditingSource(value: (source: any) => any) {
    this._cloneEditingSource = !value
      ? this._cloneEditingSource
      : value;
  }

  private _cloneEditingSource: (source: any) => any;

  private static _cloneSourceDefault(source: any): any {
    // 標準的な複製実装.有効な値の場合、clone()が実装されてればclone()、なければ浅いコピーを行う.
    return !source
      ? source  // null/undefined/0(number)/空文字列(string)/false(boolean)はそのまま返す.
      : (!source.clone ? ObjectUtility.copyShallowly(source) : source.clone());
  }

  private isRestricted(read: (s: IRestrictions) => IRestriction): boolean {
    return this.editingRestrictions
        && read(this.editingRestrictions)
        && read(this.editingRestrictions).isDisabled;
  }

  @Watch("value")
  onValueUpdated(newValue: any, oldValue: any): void {
    this._updatingValue = null;
  }

  @Emit()
  input(value: any): void {}

  writeProperty(write: (source: any) => void): void {
    const source = (!!this._updatingValue && this.value !== this._updatingValue)
      ? this._updatingValue
      : this.value;
    const clone = this.cloneEditingSource(source);
    write(clone);
    this._updatingValue = clone;
    this.input(clone);
  }

  writePropertyWhenValid(write: (s: any) => void) {
    if (!this.editingSource) {
      return;
    }
    this.writeProperty(write);
  }

  async writePropertyAsync(write: (source: any) => Promise<void>): Promise<void> {
    try {
      const source = (!!this._updatingValue && this.value !== this._updatingValue)
        ? this._updatingValue
        : this.value;
      const clone = this.cloneEditingSource(source);
      await write(clone);
      this._updatingValue = clone;
      this.input(clone);
      await this.$nextTick(); // asyncしてるので更新が反映されるよう$nextTickも呼んでおく.こっち使える場合はこっち使った方が正解かも.
    } catch (e) {
      throw e;
    }
  }

  readPropertyOrDefault<T>(read: (s: any) => T, defaultValue: T) {
    return this.editingSource
      ? read(this.editingSource)
      : defaultValue;
  }
}
